export default "__VITE_ASSET__DBM$3L11__"